import { sidebarVisible, sidebarHidden } from '../LeftPane.scss';

/**
 * Returns correct styling behavior for rendering left pane
 */

export const useLeftPaneContentStyle = (showLeftPane: boolean) => {
    return showLeftPane ? sidebarVisible : sidebarHidden;
};
